import React from 'react';

import { BulbIcon } from '@/components/icons/bulb';
import { Typography } from '@/components/ui/typography';

interface CardProps {
  header: string;
  description: string;
  children: React.ReactNode;
}

export function Card({ header, description, children }: CardProps) {
  return (
    <div className="shadow-base flex w-[248px] flex-col items-start justify-center gap-2 rounded-lg bg-white p-4">
      <BulbIcon />
      <Typography variant="body2">{header}</Typography>
      <Typography variant="subtitle1">{description}</Typography>
      {children}
    </div>
  );
}
